export function methodEntries(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (!value || typeof value !== "object") return [];
  return Object.keys(value)
    .sort((a, b) => Number(a) - Number(b))
    .map((key) => value[key])
    .filter(Boolean);
}

export function groupHypothesisSteps(value) {
  const steps = methodEntries(value);
  const groups = [];
  let current = null;
  for (const entry of steps) {
    const text = typeof entry === "string" ? entry : String(entry?.step || "");
    if (/^\s*root cause\s*:/i.test(text)) {
      current = { root: entry, steps: [] };
      groups.push(current);
    } else if (current) {
      current.steps.push(entry);
    } else {
      if (!groups.length || groups[0].root) groups.unshift({ root: null, steps: [] });
      groups[0].steps.push(entry);
    }
  }
  return groups;
}

const entryText = (entry) => typeof entry === "string" ? entry : String(entry?.step || "");
const detailEntries = (entry) => methodEntries(entry?.details);
const labeledText = (value, label) => {
  const match = String(value || "").match(new RegExp(`^\\s*(?:\\*\\*)?${label}(?:\\*\\*)?\\s*:\\s*(.*)$`, "i"));
  return match?.[1]?.trim() || "";
};

export function latestCausalFinding(methods) {
  const steps = methodEntries(methods?.steps);
  let rootIndex = -1;
  for (let index = steps.length - 1; index >= 0; index -= 1) {
    if (/^\s*root cause\s*:/i.test(entryText(steps[index]))) { rootIndex = index; break; }
  }
  if (rootIndex < 0) return null;

  const root = steps[rootIndex];
  let found = "";
  let next = "";
  let testing = "";
  for (const entry of steps.slice(rootIndex)) {
    const lines = [entryText(entry), ...detailEntries(entry)];
    for (const line of lines) {
      found = labeledText(line, "Found") || found;
      next = labeledText(line, "Next") || next;
    }
    const text = entryText(entry).trim();
    if (text && !/^\s*(root cause|found|next)\s*:/i.test(text)) testing = text;
  }
  return {
    number: steps.slice(0, rootIndex + 1).filter((entry) => /^\s*root cause\s*:/i.test(entryText(entry))).length,
    rootCause: labeledText(entryText(root), "Root cause"),
    testing,
    found,
    next,
  };
}
